export const IN_PERSON_OFFICIAL = 'in_person';
export const REMOTE_OFFICIAL = 'remote';
export const REMOTE_TEST = 'remote_test';
export const IN_PERSON_TEST = 'in_person_test';